// extracted by mini-css-extract-plugin
export default {"content__desktop":"styles_content__desktop__8RF7t","close__button":"styles_close__button__R4S9t","content__mobile":"styles_content__mobile__r+sLN"};